module.exports = __webpack_public_path__ + "static/Group 7199-813e29eb209b12e18b8b8cd1fa97c4c0.png";